import { ShoppingBag, Truck } from "lucide-react";
import { useTray } from "../context/TrayContext";

const OPTIONS = [
  { value: "Pickup", label: "Pickup", icon: ShoppingBag },
  { value: "Delivery", label: "Delivery", icon: Truck },
];

export const FulfillmentToggle = ({ light = false }) => {
  const { fulfillment, setFulfillment } = useTray();
  return (
    <div
      data-testid="fulfillment-toggle"
      className={`grid grid-cols-2 gap-1.5 rounded-xl border-2 p-1.5 ${
        light ? "border-nosh-cream/25" : "border-nosh-border bg-white"
      }`}
    >
      {OPTIONS.map((o) => {
        const Icon = o.icon;
        const active = fulfillment === o.value;
        return (
          <button
            key={o.value}
            data-testid={`fulfillment-${o.value.toLowerCase()}`}
            onClick={() => setFulfillment(o.value)}
            className={`flex items-center justify-center gap-2 rounded-lg px-3 py-2.5 font-poster text-xs font-bold uppercase tracking-wide transition-colors ${
              active
                ? "bg-nosh-green text-nosh-cream"
                : light
                ? "text-nosh-cream/70 hover:text-nosh-cream"
                : "text-nosh-ink/60 hover:text-nosh-green"
            }`}
          >
            <Icon className="h-4 w-4" />
            {o.label}
          </button>
        );
      })}
    </div>
  );
};

export default FulfillmentToggle;
